export default "__VITE_ASSET__BhcuWQsx__"